import i18n from 'i18n';
import {
  AvgMaxCountAccess,
  PeriodCountAccess,
} from 'modules/environments/interfaces';

export const filterPeriodOptions = (
  setPeriodFilterFunction: (prop: string) => void
) => [
  {
    id: 'last-24-hours',
    label: i18n.t(
      `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_24_HOURS.toUpperCase()}`
    ),
    onClick: () => setPeriodFilterFunction(PeriodCountAccess.LAST_24_HOURS),
  },
  {
    id: 'last-48-hours',
    label: i18n.t(
      `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_48_HOURS.toUpperCase()}`
    ),
    onClick: () => setPeriodFilterFunction(PeriodCountAccess.LAST_48_HOURS),
  },
  {
    id: 'last-7-days',
    label: i18n.t(
      `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_7_DAYS.toUpperCase()}`
    ),
    onClick: () => setPeriodFilterFunction(PeriodCountAccess.LAST_7_DAYS),
  },
  {
    id: 'last-15-days',
    label: i18n.t(
      `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_15_DAYS.toUpperCase()}`
    ),
    onClick: () => setPeriodFilterFunction(PeriodCountAccess.LAST_15_DAYS),
  },
  {
    id: 'last-30-days',
    label: i18n.t(
      `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_30_DAYS.toUpperCase()}`
    ),
    onClick: () => setPeriodFilterFunction(PeriodCountAccess.LAST_30_DAYS),
  },
  {
    id: 'last-60-days',
    label: i18n.t(
      `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_60_DAYS.toUpperCase()}`
    ),
    onClick: () => setPeriodFilterFunction(PeriodCountAccess.LAST_60_DAYS),
  },
];

export const filterAvgMaxOptions = (
  setAvgMaxFilterFunction: (prop: string) => void
) => [
  {
    id: 'avg',
    label: i18n.t(
      `PERFORMANCE_PAGE.${AvgMaxCountAccess.AVG.toUpperCase()}_KEY`
    ),
    onClick: () => setAvgMaxFilterFunction(AvgMaxCountAccess.AVG),
  },
  {
    id: 'max',
    label: i18n.t(
      `PERFORMANCE_PAGE.${AvgMaxCountAccess.MAX.toUpperCase()}_KEY`
    ),
    onClick: () => setAvgMaxFilterFunction(AvgMaxCountAccess.MAX),
  },
];

const dateFormat = (currentDate: Date) =>
  `${currentDate.getDate()}/${currentDate.getMonth() +
    1}-${currentDate.toLocaleTimeString('pt-BR', {
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
  })}`;

export const generateLabels = metrics =>
  metrics?.map(item => dateFormat(new Date(item?.timestamp * 1000)));

export const defaultGraphConfig = (
  data,
  displayTicks = false,
  setBeginAtZero?: boolean,
  setMax?: number,
  type = 'line',
  stepSize?: number
): any => ({
  type,
  data,
  options: {
    scaleShowLabels: false,
    responsive: true,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label(tooltipItem) {
          return tooltipItem.yLabel;
        },
      },
      displayColors: true,
    },
    plugins: {
      legend: {
        display: false,
      },
      filler: {
        propagate: false,
      },
      title: {
        display: false,
      },
    },
    interaction: {
      intersect: true,
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: true,
          },
          ticks: {
            display: displayTicks,
          },
        },
      ],
      yAxes: [
        {
          max: 10,
          gridLines: {
            display: true,
          },
          ticks: {
            display: displayTicks,
            beginAtZero: setBeginAtZero,
            max: setMax,
            stepSize,
          },
        },
      ],
    },
  },
});
